import React,{useEffect,useState,useCallback} from 'react';
import './LogOut.scss';
import className from 'classnames';
import TideEntitySelect from "../../../TideEntitySelect/TideEntitySelect";
import {employeeFullName} from "../../../../services/modelUtils/employeeUtils";
import Button from "../../../Button/Button";
import {useSelector} from "react-redux";


const LogOut = ({isOpen, onClose})=>{


    const [animateOpen,setAnimateOpen] = useState(false);
    useEffect(()=>{
        setAnimateOpen(isOpen);
        return() =>{
            setAnimateOpen(false);
        }
    },[animateOpen,isOpen]);

    const switchUser=useCallback((user)=>{
        window.localStorage.switchUser=user.username;
        window.location.reload();
    },[]);

    const stopSwitching=useCallback(()=>{
        delete window.localStorage.switchUser;
        window.location.reload();
    },[]);

    const me = useSelector(({api})=>api.me);
    const isSuperAdmin = window.localStorage.switchUser || (me && me.role && me.role.name === 'SUPER_ADMIN');

    return(
        <>
        <div className='LogOut-back-overlay' onClick={onClose}/>
        <div className={className("LogOut",animateOpen?'animateOpen':'')}>
            <div className="LogOut-plica"/>
            {isSuperAdmin&&
                <>
                <TideEntitySelect
                    entity='users'
                    filterBy='search'
                    labelCreator={labelCreator}
                    additionalApiOptions={apiOptions}
                    onChange={switchUser}
                    />
                    <Button onClick={stopSwitching}>Un-switch</Button>
                </>}
        </div>
        </>
    )
};
export default LogOut;

const apiOptions={preventUserSwitch:true};
const labelCreator=(u)=>employeeFullName(u.employee);
